import * as React from 'react';
import { Box, GlobalStyles } from '@mui/material';

const fontFaceGlobalStyles = (
    <GlobalStyles
        styles={{
            '@font-face': {
                fontFamily: 'SimpleLineIcon',
                src: `url(${process.env.PUBLIC_URL}/fonts/Simple-Line-Icons-Pro.ttf)`
            }
        }}
    />
);

export const LineIconProvider: React.FC<React.PropsWithChildren> = ({ children }) => (
    <>
        {fontFaceGlobalStyles}
        <Box flex={1}>{children}</Box>
    </>
);
